import { Row, Card } from 'antd'

import NeedStyle from '../../styles/NeedTransparency.module.css'

const NeedTransparency = () => {
  return (
    <div className={`${NeedStyle["need-transparency-screen"]}`}>
      <Row justify="center">
        <Card className={`${NeedStyle["need-transparency-card"]}`}>
          <article>
            <span>AUGUST 21, 2020 &nbsp;|&nbsp;NJLJ.COM</span>
            <h1 className={`${NeedStyle["need-transparency-title"]}`}>Need for Transparency First; Reach Economic Equality Next</h1>
            <h4 className={`${NeedStyle["blog-sub-title"]}`}>
              What happens when the public is required by law to buy a product that does not come with transparency?
              That scenario, unacceptable to most, is happening in the world of car insurance, here in New Jersey—and
              nationwide.
            </h4>
            <p className={`${NeedStyle["need-transparency-author-name"]}`}>By Eric S. Poe</p>
            <hr />
            <figure className={`${NeedStyle["right"]}`}>
              <img alt="Eric Poe - CURE Ceo" src="https://assets.cure.com/img/main-site/eric_half_pregnant.jpeg" />
              <figcaption>Eric S. Poe, Esq., CPA</figcaption>
            </figure>
            <p>
              Transparency is one of the most prevalent words used in corporate mission statements today. It can be
              argued that a company’s perceived truthfulness and open communication with consumers can make or break the
              business. But what happens when the public is required by law to buy a product that does not come with
              transparency? That scenario, unacceptable to most, is happening in the world of car insurance, here in New
              Jersey—and nationwide.
            </p>
            <p>
              The lack of transparency is glaringly clear as some of the most recognizable car insurance companies—yes
              the ones flooding the airwaves with discounts and corporate pledges—are using “income proxies” like
              educational attainment and occupation in determining car insurance rates. Consumers are unaware of the
              fact that they are being charged higher rates based on these income proxies regardless of whether they
              have a spotless driving record. To be clear, credit scores require notification under the Fair Credit
              Reporting Act (FCRA) of an adverse decision being made based on one’s score. In this case, there is no
              notice required by law for these companies that are making such decisions and charging higher rates to
              those who do not have college degrees or who hold traditionally lower paying jobs.
            </p>
            <p>
              This practice of using income proxies can, and should, be likened to “constructive discharge” in
              employment law where employers will intentionally make one’s work environment so difficult and
              uncomfortable, that the employee has no practical alternative but to resign. In the case of car insurance,
              I call it “constructive rejection”—when car insurers charge such high rates to lower income consumers,
              that they are forced to either choose another insurance company or, worse, go uninsured. Either way, the
              car insurance company circumvents technically “rejecting” the driver (which is prohibited by law based
              upon these criteria) and instead simply make their rates unaffordable.
            </p>

            <h5>By Way of Background</h5>
            <p>
              This is not new in the insurance industry. In 2000, a National Association of Insurance Commission (NAIC)
              voluntary working group, the Center for Economic Justice, and the American Council of Life Insurers joined
              together to address how to combat such “proxy discrimination,” where for decades some life insurers simply
              substituted “education” level and “occupation” for “race” upon the passage of the Civil Rights Act of
              1965. This enabled them to subvert the law and continue selling racially discriminatory life insurance
              policies.
            </p>
            <p>
              Despite the NAIC working group’s findings and multi-million-dollar settlements in the life insurance
              industry, educational attainment, occupational status and other “income Eric S. Poe proxies” are still
              being used today to set auto insurance rates. And, in New Jersey, where consumers have no choice but to
              purchase car insurance, insurers continue to use these “income proxies.”
            </p>

            <h5>Closer to Home</h5>

            <p>
              In 1998, the New Jersey Legislature rolled out a reform package, known as the Automobile Insurance Cost
              Reduction Act (AICRA), to change the way insurance companies utilized underwriting rules to set rate
              levels. N.J.S.A. 17:29A-46.2. The laws created a tiered system that allowed for factors that included
              driving record and driving experience, but also permitted the use of other characteristics.
            </p>

            <p>
              These new laws opened the door for insurance companies to use factors like “insurance scores,” which
              incorporate credit history. At the same time, a key component of the legislation included a provision that
              made all underwriting rules “subject to public inspection.” N.J.S.A. 17:29A-46.2(b). Yet, despite this
              clear requirement, “underwriting rules” that relate to the use of “income proxies” seem to be shielded
              from the public.
            </p>

            <figure className={`${NeedStyle["left"]}`}>
              <img
                alt="car"
                className={`${NeedStyle["need-transparency-left-img"]}`}
                src="https://assets.cure.com/img/main-site/need_transparency_car.png"
              />
            </figure>

            <p>
              The dust cloud surrounding public exposure of the underwriting process for automobile insurance became
              clear when, in April 2006, during preparation for an upcoming public hearing, New Jersey State Senator Nia
              H. Gill, a member of the Senate Commerce Committee, sought certain documents through the New Jersey Open
              Public Records Act, N.J.S.A. 47:1A-1 et seq. (OPRA), relating to GEICO and any other car insurance
              companies that utilized occupation, education, or both, as underwriting factors. The requests included
              those documents related to rating systems, underwriting rules, and rating manuals filed with the
              Department of Banking and Insurance (DOBI) at the time, who in large part, produced very few responsive
              documents. Specifically, at the time, DOBI denied the request for most of the documents requested, arguing
              that they contained insurers’ proprietary financial information or information that, if disclosed, would
              provide an advantage to the insurer’s competitors.
            </p>
            <p>
              Unable to resolve the dispute, Senator Gill filed a complaint with the Government Records Council (GRC),
              citing Section 46.2 as her basis for why the documents should have been provided by DOBI. In her
              complaint, Senator Gill relied on DOBI’s own statements regarding the public availability of such
              underwriting rules. As published in the New Jersey Register, DOBI noted that “an insurer’s alternate
              underwriting rules, as well as its primary underwriting rules, are utilized in determining whether to
              decline or non-renew a risk. Insureds must be provided with the rationale and basis for such a
              determination.” 36 N.J.R. 1929(a) (emphasis added). In 2007, GEICO sought to intervene in the proceedings,
              citing the need to protect its confidential and proprietary records. While the GRC denied GEICO’s motion
              to intervene, this decision was reversed by the Appellate Division in Gill v. New Jersey Department of
              Banking and Insurance, 404 N.J. Super. 1 (App. Div. 2008).
            </p>
            <p>
              In August 2010, following a hearing before the OAL, including an in camera review of the documents in
              dispute, the Administrative Law Judge (ALJ) determined that the withheld documents were not underwriting
              rules and therefore were not specifically subject to public inspection under Section 46.2(b). The GRC
              adopted the judge’s findings, holding that DOBI properly withheld the documents and that there was
              Shutterstock no unlawful denial of access under OPRA. In October 2010, the GRC further determined that
              DOBI complied with the prior order, which included its production of only a handful of documents found
              responsive to the OPRA requests.
            </p>

            <p>
              Senator Gill continued her quest to obtain these underwriting documents when, in 2013, she appealed the
              final decision of the GRC to the Appellate Division. In Gill v. New Jersey Department of Banking and
              Insurance, A-1801-10T4, 2013 WL 534786 (App. Div. Feb. 14, 2013), the Appellate Division affirmed the
              GRC’s decision, ending Senator Gill’s attempts to bring transparency to the underwriting process for New
              Jersey’s residents.
            </p>

            <h5>Returning to Present Day</h5>

            <p>
              Today’s news is flooded with stories exposing the unequal treatment of different segments of our society,
              and the question must be asked—why do we continue to allow discriminatory corporate practices that
              fundamentally disenfranchise and economically harm lower income sectors of our society? At this time, the
              need for transparency in insurance companies’ practices is clearer than ever
            </p>

            <p>
              Ask a poor family in America to identify their biggest asset; the answer will almost always be a car. For
              many, a car is more than just a means of transportation, it represents the only vehicle to escape poverty.
              But, ironically, the cost to insure a car for the poorer people in America is higher than the cost for
              those that are wealthier. Why? As a whole, people with lower income are less attractive consumers to
              insurers because they have lower overall spending power. Why insure poorer drivers when the wealthier
              drivers are likely to generate greater profits as they buy coverage for their homes, their lives, their
              boats and their multiple cars? This is why car insurers have advertised large discounts to “bundle” auto
              and home insurance needs, as lower income people have nothing to bundle.
            </p>

            <p>
              The concern regarding this disparity is compounded by the fact that car insurance is required by law in 48
              of 50 states, including here in New Jersey. The numbers in New Jersey alone illustrate the devastating
              impact of these underwriting practices. In the years following the state’s 2004 decision to allow auto
              carriers to use “income proxies,” such as credit scores, education, and occupation in rate-setting, the
              number of New Jersey drivers who can no longer afford car insurance exploded by 86%, and the uninsured
              motorist rate rose from 8% to 15% between 2007 and 2015. One must assume that this number is growing,
              considering the pandemic’s impact on the economy.
            </p>
            <p>
              There is ample evidence to suggest that rate-setting practices of many insurance companies are fraught
              with opinions and assumptions that are wrong. The failure of these companies to allow these practices to
              be viewed by the public and “stress-tested” keeps consumers in the dark. If the consumer does not know the
              underlying facts, data, assumptions and information relating to underwriting and rate setting, how do they
              know if the end product is fair, equitable and legal? In other words, how does the consumer know whether
              they have been the victim of discrimination?
            </p>

            <p>
              So, bringing it back to the initial question: Are profit-seeking corporate executives in the car insurance
              industry going to continue being allowed the use “income proxies” to price car insurance? Or will
              corporate America’s pledge for transparency, combined with legislative or regulatory efforts succeed in
              finally abolishing polices that have a disastrous impact on low income and less educated individuals?
            </p>

            <p>
              Public awareness of the use of these income proxies has led to a ban of their use by legislation or
              regulation in New York (2018) and Michigan (2019). But banning the practice in two states is not enough.
              Today, there is a federally proposed Prohibit Auto Insurance Discrimination Act (PAID Act – H.R. 3693) in
              the hands of the U.S. Congress and similar legislation before the New Jersey Assembly and Senate (A-4179,
              S-111). Transparency may soon see its day.
            </p>

            <hr />
            <p className={`${NeedStyle["need-transparency-author"]}`}>
              <span className={`${NeedStyle["bold"]}`}>Eric S. Poe, </span> is chief operating officer of CURE Auto Insurance, a
              notfor-profit full service provider of auto insurance in New Jersey and Pennsylvania. He is a licensed
              active New Jersey attorney and a certified public accountant.
            </p>

            <hr />
            <p className={`${NeedStyle["need-transparency-foot-note"]}`}>
              Reprinted with permission from the August 21, 2020 edition of the NEW JERSEY LAW JOURNAL.© 2021 ALM Media
              Properties, LLC. All rights reserved. Further duplication without permission is prohibited. For
              information, contact 877-256-2472, reprints@alm.com or visit{' '}
              <a
                className={`${NeedStyle["need-transparency-hyperlinks"]}`}
                href="https://almreprints.com/"
                rel="noreferrer"
                target="_blank"
              >
                www.almreprints.com
              </a>
              . NJLJ-08242020-458318
            </p>
          </article>
        </Card>
      </Row>
    </div>
  )
}

NeedTransparency.propTypes = {}

export default NeedTransparency
